import React, { useState, useEffect } from "react";
import { SelfFixtureBetsScoreAndWinner } from "../components/SelfFixtureBetsScoreAndWinner";
import { useBets } from "../context/betsContext";

const EMPTY_BET = {
	fixtureIdentifier: null,
	groupIdentifier: null,
	winnerBet: null,
	homeTeamScore: "",
	awayTeamScore: "",
};

function FixtureBets() {
	const { infoPlayerBets, getInfoPlayerBets, dateMatchs } = useBets();

	const [infoPlayerBetsWithDateChanged, setInfoPlayerBetsWithDateChanged] =
		useState(null);

	useEffect(() => {
		getInfoPlayerBets();
	}, []);

	useEffect(() => {
		if (typeof infoPlayerBets.Result === "undefined") {
			return;
		}

		const betsWithFormattedDate = infoPlayerBets.Result.map((item, index) => ({
			...item,
			fixture: {
				...item.fixture,
				rawDate: item.fixture.date,
				date: dateMatchs[index] ?? item.fixture.date,
			},
			bet: item.bet
				? {
						...item.bet,
				  }
				: {
						...EMPTY_BET,
				  },
		}));

		setInfoPlayerBetsWithDateChanged(betsWithFormattedDate);
	}, [dateMatchs, infoPlayerBets]);

	return (
		<React.Fragment>
			{/* <AlertUserSessionExpiredToken /> */}
			{!infoPlayerBetsWithDateChanged && (
				<div className='d-flex justify-content-center'>
					<div className='spinner-border' role='status'>
						<span className='visually-hidden'>Loading...</span>
					</div>
				</div>
			)}

			{/* {messageError && <h1>{messageError}</h1>} */}

			{infoPlayerBetsWithDateChanged && (
				<SelfFixtureBetsScoreAndWinner
					infoPlayerBetsWithDateChanged={infoPlayerBetsWithDateChanged}
				/>
			)}
		</React.Fragment>
	);
}

export { FixtureBets };
